import {
    Box,
    Button,
    Divider,
    Grid,
    IconButton,
    InputBase,
    Typography,
  } from "@mui/material";
  import React, { useState } from "react";
  import SearchIcon from "@mui/icons-material/Search";
  import ExpandLessIcon from "@mui/icons-material/ExpandLess"; // Collapse Icon
  import ExpandMoreIcon from "@mui/icons-material/ExpandMore"; // Expand Icon;
  import { Search } from "@mui/icons-material";
  import { WSIcons } from "../../../commonFunctions/iIcons";
import { OverViewDealsContact } from "./OverViewDealsContact";
import {  OverViewNotesContact } from "./OverViewNotesContact";
import { OverViewTaskContact } from "./OverViewTaskContact";
import { OverViewEstimation } from "./OverViewEstimation";
import { OverViewQuotation } from "./OverViewQuotation";
import { OverViewWorkOrder } from "./OverViewWorkOrder";
import { OverViewProduct } from "./OverViewProduct";
import { OverViewEmailContact } from "./OverViewEmailContact";
import { OverViewMeetingContact } from "./OverViewMeetingContact";
import { OverViewPayment } from "./OverViewPayment";
import { OverViewCallContact } from "./OverViewCallContact";

  
  
  export const OverviewSectionContact: React.FC<any> = React.memo((props) => {
    const [collapsed, setCollapsed] = useState(false);
  
    return (
      <Grid
        sx={{
        //  height: "500px", // Set the height you want for the section
         // overflowY: "auto", // Enable vertical scrolling
          borderRadius: 2,
          padding:0,
          
        }}
      >
        <Grid
          sx={{
            border: "1px solid #ddd",
            borderRadius: 2,
          }}
        >
          {/* Header Section */}
          {/* <Grid
            sx={{
              backgroundColor: "#7D79C2", // Light Purple Background
              color: "white",
              display: "flex",
              borderTopLeftRadius: 5,
              borderTopRightRadius:5,
              justifyContent: "space-between",
              alignItems: "center",
              p: 1.5,
            }}
          >
            <Typography fontWeight="bold">Recent Activities</Typography>
          </Grid> */}
  
          {/* Content Section with Search Bar and Collapse Button */}
          {/* <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            sx={{ p: 2 }}
          >
         
            <Grid item xs={8}>
              <Grid
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  alignItems: "center",
                  bgcolor: "#f1f1f1",
                  p: 1,
                  borderRadius: 2,
                }}
              >
                <Search sx={{ color: "#555" }} />
                <InputBase placeholder="Search" sx={{ ml: 1, flex: 1 }} />
              </Grid>
            </Grid>
  
        
            <Grid item xs={4} textAlign="right">
              <Typography>
                Collapse all
                <IconButton onClick={() => setCollapsed(!collapsed)}>
                  {collapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                </IconButton>
              </Typography>
  
             
              <Button
                variant="outlined"
                size="small"
                sx={{ mt: 1, textTransform: "none" }}
              >
                All Time so far
              </Button>
            </Grid>
          </Grid> */}
  
    
      
       
        </Grid>
         
        <OverViewDealsContact />
        <br></br>
        <OverViewNotesContact />
        
        <OverViewProduct/>
        <OverViewEstimation/>
        <OverViewQuotation/>
        <OverViewPayment/>
        <OverViewWorkOrder/>
        <br></br>
        <OverViewEmailContact/>
        <br></br>
        <OverViewTaskContact/>
        <br></br>
        <OverViewMeetingContact/>
        <br></br>
        <OverViewCallContact/>
        {/* <OverViewTasksContact /> */}
      </Grid>
    );
  });
  